import React, { Fragment, FunctionComponent } from "react";
import ContentPageBlock from "./ContentPage.block";
import ContentPageContent from "./ContentPageContent.model";

const ContentPage: FunctionComponent<ContentPageContent> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent: any, index) => {
                return (
                    <ContentPageBlock key={blockContent.contentUdi} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default ContentPage;